import { componentProvider } from 'js-component-framework';
import LoopingVideo from './looping-video';
import './looping-video.scss';

const loopingVideoConfig = {
  name: 'looping-video',
  component: LoopingVideo,
  querySelector: {
    video: 'video',
    button: 'button',
  },
  querySelectorAll: {},
  options: {},
};
componentProvider(loopingVideoConfig);
